const DAY_MS = 24 * 60 * 60 * 1000;

export function startOfDay(value) {
  const d = new Date(value);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/** Короткое время сообщения: «09:05». */
export function formatTime(value) {
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}

/** Метка разделителя дня в ленте: «Сегодня» / «Вчера» / «5 марта». */
export function formatDayLabel(value) {
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const today = startOfDay(new Date());
  const that = startOfDay(d);
  if (that === today) return 'Сегодня';
  if (that === today - DAY_MS) return 'Вчера';
  const opts = { day: 'numeric', month: 'long' };
  if (d.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
  return d.toLocaleDateString('ru-RU', opts);
}

/** Время в списке чатов: сегодня — «09:05», вчера — «Вчера», иначе дата. */
export function formatChatListTime(value) {
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const today = startOfDay(new Date());
  const that = startOfDay(d);
  if (that === today) return formatTime(d);
  if (that === today - DAY_MS) return 'Вчера';
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
}
